// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".vue-tabs .vue-tabs__nav{display:flex;align-items:baseline;justify-content:flex-start}.vue-tabs .vue-tabs__panel[hidden=hidden]{display:none}", ""]);
// Exports
module.exports = exports;
